import { toSafeString } from '@shared/utils';

const toSafeUserPermissions = (value, { allowNull = false } = {}) => {
  if (value === null || value === undefined) {
    return allowNull ? null : [];
  }

  if (!Array.isArray(value)) {
    return [];
  }

  return Array.from(
    new Set(
      value
        .map((permission) => {
          return toSafeString(permission);
        })
        .filter(Boolean)
    )
  );
};

export default toSafeUserPermissions;
